export default "__VITE_ASSET__BjWs0dpG__"